import { API_ROOT } from '../../config';
import { ssFetchJSON } from '../../modules/ssFetch';
import SimpleCache from '../../modules/SimpleCache';
import { DateTimeStamp } from '../../types/dateTime';

const RefundCache = new SimpleCache(15 * 60);

export const REFUND_REASONS = [
  { label: 'My client paid with cash', value: 1 },
  { label: 'I need to edit the amount charged', value: 2 },
  { label: 'I meant to cancel this appointment', value: 3 },
  { label: 'My client tipped in person', value: 4 },
  { label: 'My client paid in advance', value: 5 },
  { label: 'My client paid with a credit card', value: 6 },
];

export type RefundPayload = {
  amount: number;
  reason: string;
  notes?: string;
};

export type RefundApiResponse = {
  amount: string; // Decimal
  created: DateTimeStamp;
  refund_type: number;
};

export function refundAppointment(
  appointmentId: number,
  payload: RefundPayload,
): Promise<RefundApiResponse> {
  const url = new URL(`/api/v1/appointment/${appointmentId}/refund.json`, API_ROOT);
  RefundCache.clear();
  return ssFetchJSON(url.toString(), {
    method: 'POST',
    body: payload,
  });
}

export function getRefunds(appointmentId): Promise<RefundApiResponse[]> {
  const url = new URL(`/api/v1/appointment/${appointmentId}/refund.json`, API_ROOT);
  return ssFetchJSON(url.toString(), {
    ssCache: RefundCache,
  });
}
